<template>
  <div class="col-12 col-xl-12" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
         <!-- Filters -->
        <div class="px-3 px-xl-4 pt-3 pb-2">
          <div class="row g-2 align-items-end">
            <div class="col-6 col-md-2 col-lg-2">
              <select
                class="form-select form-select-sm"
                v-model="typeFilter"
                @change="handleTypeFilter"
              >
                <option value="all">{{ $t('common.all') }}</option>
                <option value="credit">{{ $t('salary_management.credit') }}</option>
                <option value="debit">{{ $t('salary_management.debit') }}</option>
              </select>
            </div>

         <div class="col-6 col-md-2 col-lg-2">
  <div class="input-group input-group-sm">
    <input
      type="date"
      class="form-control"
      v-model="fromDate"
      @change="handleDateChange"
    />
        <span class="input-group-text">{{ $t('common.from') }}</span>

  </div>
</div>

<div class="col-6 col-md-2 col-lg-2">
  <div class="input-group input-group-sm">
    <input
      type="date"
      class="form-control"
      v-model="toDate"
      @change="handleDateChange"
    />
        <span class="input-group-text">{{ $t('common.to') }}</span>

  </div>
</div>

            <div class="col-md-1 d-none d-md-block">
              <button
                class="btn btn-outline-secondary btn-sm w-100"
                @click="resetFilters"
                :title="$t('guardians.filters.reset')"
              >
                <i class="fas fa-filter-circle-xmark"></i>
              </button>
            </div>

            <div class="col-6 col-sm-6 col-md-4 col-lg-4 position-relative">
              <input
                type="text"
                class="form-control form-control-sm ps-5"
                :placeholder="$t('salary_management.search_placeholder')"
                v-model="searchTerm"
                @input="handleSearch"
                style="padding-right: 12px"
              />
              <span class="position-absolute start-0 top-50 translate-middle-y ps-3">
                <i class="fas fa-search"></i>
              </span>
            </div>

            <div class="col-6 d-md-none">
              <button class="btn btn-outline-secondary btn-sm w-100" @click="resetFilters">
                <i class="fas fa-filter-circle-xmark"></i> {{ $t('guardians.filters.reset') }}
              </button>
            </div>

            <div class="col-12 col-md-auto ms-md-auto d-flex gap-2">
              <button class="btn btn-outline-secondary btn-sm" @click="onPrint">
                <i class="fas fa-print me-1"></i>{{ $t('salary_management.print') }}
              </button>
              <button class="btn btn-outline-success btn-sm" @click="onExportExcel">
                <i class="fas fa-file-excel me-1"></i>{{ $t('salary_management.export_excel') }}
              </button>
              <button class="btn btn-outline-danger btn-sm" @click="onExportPdf" :disabled="exportingPdf">
                <i class="fas fa-file-pdf me-1"></i>{{ $t('salary_management.export_pdf') }}
              </button>
            </div>
          </div>
        </div>
    <!-- Card -->
    <div class="card mb-3 mb-xxl-5 me-xxl-4" style="margin-top: 2.5rem; overflow: visible">
      <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2" style="height: 60px">
        <div class="bg-gradient-primary shadow-primary border-radius-lg pt-4 pb-3 h-100">
          <h6 class="text-white text-capitalize ps-3 pe-3" style="font-size: 1rem">
            {{ $t('salary_management.statements') }}
          </h6>
        </div>
      </div>

      <div class="card-body px-0 pb-2 pe-xl-3">
   

        <div class="table-responsive p-1 p-xl-4">
          <LoadingSpinner
            v-if="isLoading"
            :message="$t('salary_management.loading')"
            class="py-5"
          />

          <template v-else>
            <!-- Mobile cards -->
            <div class="d-block d-xl-none mt-2">
              <div v-if="paged.length === 0" class="text-center py-3 text-muted">
                {{ $t('salary_management.no_statements') }}
              </div>

              <div v-for="s in paged" :key="'m-' + s.id" class="card mb-3 mx-2">
                <div class="card-body py-2">
                  <div class="d-flex justify-content-between align-items-start">
                    <div>
                      <h6 class="mb-0 text-sm">
                        <i class="fas fa-calendar-alt me-1"></i> {{ s.date }}
                      </h6>
                      <p class="text-xs text-muted mb-1">{{ s.description || '—' }}</p>
                      <p class="text-xs text-muted mb-0">{{ s.model_name || '—' }}</p>
                    </div>
                    <div class="text-end">
                      <div class="text-xs">
                        <span class="badge bg-success-subtle text-dark me-1">
                          {{ $t('salary_management.credit') }}
                        </span>
                        <strong>{{ s.credit }}</strong>
                      </div>
                      <div class="text-xs">
                        <span class="badge bg-danger-subtle text-dark me-1">
                          {{ $t('salary_management.debit') }}
                        </span>
                        <strong>{{ s.debit }}</strong>
                      </div>
                      <div class="text-xs mt-1">
                        <span class="badge bg-secondary-subtle text-dark me-1">
                          {{ $t('salary_management.balance') }}
                        </span>
                        <strong>{{ s.balance }}</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Desktop table -->
            <table class="table align-items-center mb-0 d-none d-xl-table">
              <thead>
                <tr>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7">
                    {{ $t('salary_management.date') }}
                  </th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7">
                    {{ $t('salary_management.description') }}
                  </th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7">
                    {{ $t('salary_management.employee') }}
                  </th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-center">
                    {{ $t('salary_management.credit') }}
                  </th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-center">
                    {{ $t('salary_management.debit') }}
                  </th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-center">
                    {{ $t('salary_management.balance') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="paged.length === 0">
                  <td colspan="6" class="text-center py-4 text-muted">
                    <i class="fas fa-receipt fa-2x mb-2"></i>
                    <p class="mb-0">{{ $t('salary_management.no_statements') }}</p>
                  </td>
                </tr>

                <tr v-for="s in paged" :key="s.id">
                  <td>
                    <div class="d-flex px-3 py-1">
                      <div class="d-flex flex-column justify-content-center">
                        <h6 class="mb-0 text-md">{{ s.date }}</h6>
                      </div>
                    </div>
                  </td>
                  <td>
                    <p class="text-xs mb-0 text-truncate" style="max-width: 240px;">
                      {{ s.description || '—' }}
                    </p>
                  </td>
                  <td>
                    <p class="text-xs font-weight-bold mb-0">{{ s.model_name || '—' }}</p>
                  </td>
                  <td class="align-middle text-center"><span class="text-sm">{{ s.credit }}</span></td>
                  <td class="align-middle text-center"><span class="text-sm">{{ s.debit }}</span></td>
                  <td class="align-middle text-center"><span class="text-sm">{{ s.balance }}</span></td>
                </tr>
              </tbody>
            </table>
          </template>
        </div>

        <Pagination :pagination="pagination" @page-changed="onPageChanged" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toastification';
import { useI18n } from 'vue-i18n';
import { debounce } from 'lodash';
import LoadingSpinner from '@/components/common/LoadingSpinner.vue';
import Pagination from '@/components/common/PaginationControls.vue';
import { useTableExport, formatPrintDate } from '@/composables/useTableExport';

const store = useStore();
const toast = useToast();
const { t } = useI18n();
const { printTable, exportExcel, exportPdf } = useTableExport();
const exportingPdf = ref(false);

const isLoading = ref(false);
const searchTerm = ref('');
const typeFilter = ref('all');
const fromDate = ref('');
const toDate = ref('');

const handleSearch = debounce(() => {}, 300);
const handleTypeFilter = () => {};
const handleDateChange = () => {};

const resetFilters = () => {
  searchTerm.value = '';
  typeFilter.value = 'all';
  fromDate.value = '';
  toDate.value = '';
};

const page = ref(1);
const perPage = ref(10);

const all = computed(() => store.getters['salaryManagement/allStatements'] || []);

const filtered = computed(() => {
  const q = (searchTerm.value || '').trim().toLowerCase();
  const from = fromDate.value ? new Date(fromDate.value) : null;
  const to = toDate.value ? new Date(toDate.value) : null;
  const type = typeFilter.value;

  return all.value.filter(s => {
    const hay = `${s.description || ''} ${s.date || ''} ${s.model_name || ''}`.toLowerCase();
    if (q && !hay.includes(q)) return false;

    if (from || to) {
      const d = s.date ? new Date(s.date) : null;
      if (!d) return false;
      if (from && d < from) return false;
      if (to && d > to) return false;
    }

    if (type === 'debit' && !(Number(s.debit) > 0)) return false;
    if (type === 'credit' && !(Number(s.credit) > 0)) return false;

    return true;
  });
});

const paged = computed(() => {
  const start = (page.value - 1) * perPage.value;
  return filtered.value.slice(start, start + perPage.value);
});

// Filtering/pagination both happen client-side over the full statements
// list already loaded into the store, so this object is derived rather
// than fetched — PaginationControls just needs the same shape a
// server-paginated page would give it.
const pagination = computed(() => {
  const totalItems = filtered.value.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / perPage.value));
  const from = totalItems === 0 ? 0 : (page.value - 1) * perPage.value + 1;
  const to = Math.min(page.value * perPage.value, totalItems);
  return {
    currentPage: page.value,
    perPage: perPage.value,
    totalItems,
    totalPages,
    from,
    to,
  };
});

const onPageChanged = (newPage) => {
  page.value = newPage;
};

watch([searchTerm, typeFilter, fromDate, toDate, perPage], () => {
  page.value = 1;
});

const statementColumns = () => [
  { key: 'date', label: t('salary_management.date') },
  { key: 'description', label: t('salary_management.description') },
  { key: 'model_name', label: t('salary_management.employee') },
  { key: 'credit', label: t('salary_management.credit') },
  { key: 'debit', label: t('salary_management.debit') },
  { key: 'balance', label: t('salary_management.balance') },
];

const onPrint = () => {
  printTable({
    title: t('salary_management.statements'),
    subtitleLines: [`${t('salary_management.print_date')}: ${formatPrintDate()}`],
    columns: statementColumns(),
    rows: filtered.value,
  });
};

const onExportExcel = () => {
  exportExcel({
    title: t('salary_management.statements'),
    filename: 'salary-statements',
    columns: statementColumns(),
    rows: filtered.value,
  });
};

const onExportPdf = async () => {
  exportingPdf.value = true;
  try {
    await exportPdf({
      title: t('salary_management.statements'),
      filename: 'salary-statements',
      subtitleLines: [`${t('salary_management.print_date')}: ${formatPrintDate()}`],
      columns: statementColumns(),
      rows: filtered.value,
    });
  } catch (e) {
    toast.error(e?.response?.data?.message || t('common.error'));
  } finally {
    exportingPdf.value = false;
  }
};

const fetchAll = async () => {
  isLoading.value = true;
  try {
    await store.dispatch('salaryManagement/fetchAllStatements');
  } catch (e) {
    toast.error(e?.response?.data?.message || t('common.error'));
  } finally {
    isLoading.value = false;
  }
};

onMounted(fetchAll);
</script>

<style scoped>
.bg-danger-subtle { background-color: rgba(220, 53, 69, 0.1); }
.bg-success-subtle { background-color: rgba(25, 135, 84, 0.1); }
.bg-secondary-subtle { background-color: rgba(108, 117, 125, 0.1); }
</style>
